import paths from "@icarius-router/paths";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("evaluationProcessCode"),
            field: 'processCode',
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("evaluationProcessName"),
            field: 'processName',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("evaluationType"),
            field: 'evaluationTypeString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("calibrationState"),
            field: 'calibrationStatusString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("classificationState"),
            field: 'classificationStatusString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("evaluationStatus"),
            field: 'evaluationStatusString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("creationDate"),
            field: 'creationDate',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("evaluationStartDate"),
            field: 'evaluationStartDate',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("evaluationEndDate"),
            field: 'evaluationEndDate',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("evaluationYear"),
            field: 'evaluationYear',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("evaluationPeriodShort"),
            field: 'evaluationPeriod',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("requiredSeniorityMonths"),
            field: 'months',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            cellClass: "currencyValueNoDecimal",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("finalPerformanceRatingType"),
            field: 'performanceScoreTypeString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("finalPotentialNoteType"),
            field: 'potentialScoreTypeString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("usesMedalPoints"),
            field: 'usesMedalPointsString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("periodForObjectives"),
            field: 'objectivePeriodString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("descendingWeighted"),
            field: 'descendantWeight',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("selfEvaluationWeight"),
            field: 'selfEvaluationWeight',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("ascendingWeighted"),
            field: 'ascendantWeight',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("peerWeightedScore"),
            field: 'pairWeight',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("performancePointsFromFor9Boxes1"),
            field: 'performanceFrom1',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("performancePtsFor9Boxes1"),
            field: 'performanceTo1',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("performancePointsFromFor9Boxes2"),
            field: 'performanceFrom2',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("performancePointsFor9Boxes2"),
            field: 'performanceTo2',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("performancePointsFromFor9Boxes3"),
            field: 'performanceFrom3',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("performancePointsUntilFor9Boxes3"),
            field: 'performanceTo3',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("potentialPointsFromFor9boxes1"),
            field: 'potentialFrom1',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("performancePointsFor9Boxes1"),
            field: 'potentialTo1',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("potentialPointsFromFor9Boxes2"),
            field: 'potentialFrom2',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("potentialPointsFor9boxes2"),
            field: 'potentialTo2',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("potentialPointsFromFor9boxes3"),
            field: 'potentialFrom3',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("potentialPtsFor9Boxes3"),
            field: 'potentialTo3',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("currentStartDate"),
            field: 'courseStartDate',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("finalRatingDate"),
            field: 'calificationEndDate',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("calibrationStartDate"),
            field: 'calibrationStartDate',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("feedbackStartDate"),
            field: 'feedbackStartDate',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("classificationStartDate"),
            field: 'classificationStartDate',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.evaluationProcessDefinition],
        config: {
            headerName: getLocalizedString("closingDate"),
            field: 'courseEndDate',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: ['evaluationProcessDefinitionCheckCollaborators'],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: 'Código de empleado',
            filter: 'agSetColumnFilter',
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
        }
    },
    {
        pages: ['evaluationProcessDefinitionCheckCollaborators'],
        config: {
            headerName: getLocalizedString("nameAndSurname"),
            field: 'Apellido y nombres',
            filter: 'agTextColumnFilter',
        }
    },
    {
        pages: ['evaluationProcessDefinitionCheckCollaborators'],
        config:
        {
            headerName: getLocalizedString("state"),
            field: "Estado",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['evaluationProcessDefinitionCheckCollaborators'],
        config: {
            headerName: getLocalizedString("incomeDate"),
            field: 'Fecha de contratación',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: ['evaluationProcessDefinitionCheckCollaborators'],
        config: {
            headerName: getLocalizedString("position"),
            field: 'Cargo',
            filter: 'agSetColumnFilter',
        }
    },
    {
        pages: ['evaluationProcessDefinitionCheckCollaborators'],
        config: {
            headerName: getLocalizedString("function"),
            field: 'Función',
            filter: 'agSetColumnFilter',
        }
    },
    {
        pages: ['evaluationProcessDefinitionCheckCollaborators'],
        config: {
            headerName: getLocalizedString("fType"),
            field: 'Tipo de funcionario',
            filter: 'agSetColumnFilter',
        }
    },
    {
        pages: ['evaluationProcessDefinitionCheckCollaborators'],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: 'Lugar de trabajo',
            filter: 'agSetColumnFilter',
        }
    },
    {
        pages: ['evaluationProcessDefinitionCheckCollaborators'],
        config: {
            headerName: getLocalizedString("management"),
            field: 'Gerencia',
            filter: 'agSetColumnFilter',
        }
    },
    {
        pages: ['evaluationProcessDefinitionCheckCollaborators'],
        config: {
            headerName: getLocalizedString("department"),
            field: 'Departamento',
            filter: 'agSetColumnFilter',
        }
    },
    {
        pages: ['evaluationProcessDefinitionCheckCollaborators'],
        config: {
            headerName: getLocalizedString("costCenter"),
            field: 'Centro de costo de gestión',
            filter: "agSetColumnFilter",
        }
    },
]